// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const storageSections: PaneSection[] = [
  {
    section: 'settings-storage-intro',
    title: 'Storage',
    body: 'This pane shows how much space Ping is using on this device to keep images and media handy. Clearing it is safe, since anything still in your chats downloads again when you open it.',
  },
  {
    section: 'settings-storage-usage',
    title: 'Media cache',
    body: 'This card shows the total space your saved media is taking up right now. If a limit is known, the bar shows how much of it you have used.',
  },
  {
    section: 'settings-storage-breakdown',
    title: 'What is using space',
    body: 'This breaks the total down by type so you can see where the space is going, such as images and avatars.',
  },
  {
    section: 'settings-storage-clear',
    title: 'Clear media cache',
    body: 'Use this to free up space now. Your images and media will download again the next time you open them.',
  },
];
